// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1cYp7","content":"LoadingAlert_content__2vqCm"};